<template>
  <div id="new-document">
    <PageTitle v-if="id==''"
      title="Document toevoegen"
      description="Documenten en downloads kunnen via de app worden gedownload door de gebruiker. Houd er rekening mee dat niet elk bestandstype op een smartphone geopend kan worden."
    ></PageTitle>
    <PageTitle v-if="id!=''"
      title="Document aanpassen"
      description="Als er een bestand is gekoppeld is hieronder de bestandsnaam zichtbaar. Wanneer je een nieuw bestand kiest wordt de oude verwijderd."
    ></PageTitle>

    <form @submit.prevent>
      <div class="form-group float-right">
        <button @click="cancel" class="btn btn-light mr-2">Annuleren</button>
        <button @click="saveItem(false)" class="btn btn-warning mr-2">Opslaan als concept</button>
        <button @click="saveItem(true)" class="btn btn-success">Opslaan en publiceren</button>
      </div>
      <Storage path="downloads/" v-on:setUrl="setUrl" v-on:setFilename="setFilename" :initialFilename="fileName"></Storage>

      <div class="form-group">
        <label for="title">Titel</label>
        <input type="text" class="form-control" placeholder="Titel" v-model="title" />
      </div>
      <div class="form-group">
        <label for="folder">Categorie of map</label>
        <input type="text" class="form-control" placeholder="map" v-model="folder" />
      </div>
      <div class="form-group">
        <label for="section">Beschrijving</label>
        <textarea class="form-control" id="section" v-model="description" rows="5"></textarea>
      </div>

      <Selectoptions v-on:setOptions="setOptions"></Selectoptions>
    </form>
  </div>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import PageTitle from "@/components/PageTitle.vue";
import Storage from "@/components/Storage.vue";
import Selectoptions from "@/components/Selectoptions.vue";
var firestorage = fb.firestorage;

export default {
  name: "new-document",
  components: {
    PageTitle,
    Storage,
    Selectoptions
  },
  data() {
    return {
      title: "",
      description: "",
      checkedEstablishments: [],
      checkedPositions: [],
      downloadURL: "",
      fileName: "",
      id: "",
      folder: ""
    };
  },
  methods: {
    setOptions(data) {
      this.checkedPositions = data.checkedPositions;
      this.checkedEstablishments = data.checkedEstablishments;
    },
    setUrl(url) {
      this.downloadURL = url;
    },
    setFilename(fn) {
      this.fileName = fn;
    },
    saveItem(live) {
      // @var live: boolean
      var now = new Date();

      if (this.id == "") {
        fb.companiesCollection
          .doc(this.$cookies.get("company"))
          .collection("downloads")
          .add({
            can_comment: false,
            date_created: now.toISOString(),
            created_by: this.$cookies.get("user"),

            title: this.title,
            description: this.description,
            status: live ? "live" : "concept",
            type: "download", // TODO type document
            folder: this.folder == "" ? 'overige' : this.folder,
            url: this.downloadURL,
            filename: this.fileName,
            establishments:
              this.checkedEstablishments.length > 0
                ? this.checkedEstablishments
                : null,
            positions:
              this.checkedPositions.length > 0 ? this.checkedPositions : null
          })
          .then(docRef => {
            console.log(docRef.id);
            if (live) this.addNotification(docRef.id);
            this.$router.push("/documents");
          })
          .catch(error => console.log(error));
      } else {
        var docId = this.id;
        fb.companiesCollection
          .doc(this.$cookies.get("company"))
          .collection("downloads")
          .doc(docId)
          .update({
            can_comment: false,
            date_updated: now.toISOString(),
            updated_by: this.$cookies.get("user"),
            title: this.title,
            description: this.description,
            status: live ? "live" : "concept",
            type: "download", // TODO type document
            folder: this.folder == "" ? 'overige' : this.folder,
            url: this.downloadURL != "" ? this.downloadURL : this.url,
            filename: this.fileName,
            establishments:
              this.checkedEstablishments.length > 0
                ? this.checkedEstablishments
                : null,
            positions:
              this.checkedPositions.length > 0 ? this.checkedPositions : null
          })
          .then(() => {
            if (live) this.addNotification(docId);
            this.$router.push("/documents");
          })
          .catch(error => console.log(error));
      }
    },
    addNotification(docId) {
      /*
        adds a notification to fbase when published
        this will trigger a firebase function to send a push notification to effected users
        */

      this.$confirm({
        message: `Wil je nu een automatische pushnotificatie sturen?`,
        button: {
          no: "overslaan",
          yes: "verzenden"
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: confirm => {
          var now = new Date();
          fb.notificationsCollection
            .add({
              type: "download",
              refid: docId,
              date: now,
              created_by: this.$cookies.get("user"),
              title: this.title,
              message:
                "Er is een nieuw bestand beschikbaar. Je vindt dit in downloads onder de categorie " + (this.folder == "" ? 'overige' : this.folder),
              establishments:
                this.checkedEstablishments.length > 0
                  ? this.checkedEstablishments
                  : null,
              positions:
                this.checkedPositions.length > 0 ? this.checkedPositions : null,
              hidden: true,
              company: this.$cookies.get("company"),
              sendPush: confirm
            })
            .catch(error => console.log(error));
        }
      });
    },
    cancel() {
      // document? weggooien dan
      if (this.downloadURL != "") {
        firestorage
          .ref(
            "downloads/" + this.$cookies.get("company") + "/" + this.fileName
          )
          .delete()
          .then(() => {
            this.$router.go(-1);
          })
          .catch(error => {
            console.error(`file delete error occured: ${error}`);
          });
      } else {
        this.$router.go(-1);
      }
    }
  },

  beforeRouteEnter(to, from, next) {
    if (to.params.id && to.params.id != "new") {
      fb.companiesCollection
        .doc(window.$cookies.get("company"))
        .collection("downloads")
        .doc(to.params.id)
        .get()
        .then(doc => {
          console.log(doc.data());
          next(vm => {
            vm.id = doc.id;
            vm.title = doc.data().title;
            vm.description = doc.data().description;
            if (doc.data().establishments != null)
              vm.checkedEstablishments = doc.data().establishments;
            if (doc.data().positions != null)
              vm.checkedPositions = doc.data().positions;
            vm.url = doc.data().url ?? "";
            vm.fileName = doc.data().filename ?? "";
            vm.folder = doc.data().folder ?? "";
           // vm.initialDoc = doc.data().url ?? "";
            vm.fileName = doc.data().filename ?? "";
          });
        });
    } else {
      next();
    }
  }
};
</script>